import {
  CHANGE_CURRENT_PAGE,
  CHANGE_SEARCH_STRING,
  CHANGE_SORT,
  CHANGE_ITEMS_PER_PAGE
} from "@/store/common/types";

export const sortSearchPaginateActions = {
  changeCurrentPage({ commit }, value) {
    commit({
      type: CHANGE_CURRENT_PAGE,
      payload: value
    });
  },

  changeSort({ commit }, sorting) {
    commit({
      type: CHANGE_SORT,
      payload: sorting
    });
  },

  changeSearchString({ commit }, value) {
    commit({
      type: CHANGE_SEARCH_STRING,
      payload: value
    });
  },

  changeItemPerPage({ commit }, val) {
    commit({
      type: CHANGE_ITEMS_PER_PAGE,
      payload: val
    });
  }
};
